<dx-select-box
  fieldTemplate="field"
  valueExpr="id"
  label="Category"
  labelMode="floating"
  stylingMode="outlined"
  [dataSource]="this.categories"
  [validationStatus]="validationStatus"
  [validationErrors]="validationErrors"
  validationMessageMode="always"
  (onValueChanged)="onCategorySelectionChanged($event)"
  [showDropDownButton]="false"
  [value]="selectedCategory"
  [searchEnabled]="true"
  searchExpr="name"
>
  <div *dxTemplate="let data of 'field'" class="custom-select-template">
    <mat-icon
      [style]="{
        width: '24px',
        height: '24px',
        fontSize: '24px',
        color: data?.color,
        display: 'inline-block',
        zIndex: 100,
        margin: '0 -16px 0 10px'
      }"
      *ngIf="data?.icon"
    >
      {{ data.icon }}
    </mat-icon>
    <dx-text-box
      [value]="data?.name"
      placeholder="Select a category or create a new one"
      [inputAttr]="{ 'aria-label': 'Name' }"
    ></dx-text-box>
    <mat-icon svgIcon="plus-16" matTooltip="Create" (click)="iconClick($event, 'ADD')"></mat-icon>
    <mat-icon *ngIf="!!data" svgIcon="edit-16" matTooltip="Update" (click)="iconClick($event, 'EDIT', data)"></mat-icon>
  </div>
  <div *dxTemplate="let data of 'item'" class="custom-item-template">
    <mat-icon
      [style]="{
        width: '16px',
        height: '16px',
        fontSize: '16px',
        color: data?.color,
        display: 'inline-block',
        zIndex: 100,
        margin: '0 8px 0 0'
      }"
    >
      {{ data.icon }}
    </mat-icon>
    {{ data.name }}
    <mat-icon svgIcon="trash-16" (click)="iconClick($event, 'DELETE', data)"></mat-icon>
  </div>
</dx-select-box>
<dx-popup
  [(visible)]="popupEditorVisible"
  [width]="500"
  [height]="380"
  [showTitle]="true"
  [title]="popupTitle"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [wrapperAttr]="{ class: 'custom-popup-wrapper' }"
>
  <div class="custom-popup-content">
    <dx-text-box label="Name*" labelMode="floating" stylingMode="outlined" [(value)]="categoryName"></dx-text-box>
    <dx-color-box label="Color" labelMode="floating" stylingMode="outlined" [(value)]="categoryColor"></dx-color-box>
    <div class="icon-input">
      <dx-text-box label="Icon" labelMode="floating" stylingMode="outlined" [(value)]="categoryIcon"></dx-text-box>
      <mat-icon *ngIf="categoryIcon" [style]="{ color: categoryColor }">{{ categoryIcon }}</mat-icon>
    </div>
    <div id="help">
      Open the <a href="https://fonts.google.com/icons" target="_blank" rel="noopener">icon library</a>, choose an icon, and look at the
      bottom of the right-hand panel to find its name. Copy the name and paste it into the textbox above.
    </div>
  </div>
  <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="cancelButtonOptions"></dxi-toolbar-item>
  <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="saveButtonOptions"></dxi-toolbar-item>
</dx-popup>
